


















































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {

  private communityMedia = [
    {
      icon: [ 'fab', 'youtube' ],
      link: 'https://sitcon.org/youtube'
    },
    {
      icon: [ 'fab', 'facebook-f' ],
      link: 'https://sitcon.org/facebook'
    },
    {
      icon: [ 'fab', 'twitter' ],
      link: 'https://sitcon.org/twitter'
    },
    {
      icon: [ 'fab', 'telegram-plane' ],
      link: 'https://sitcon.org/telegram'
    },
    {
      icon: [ 'fab', 'flickr' ],
      link: 'https://sitcon.org/flickr'
    }
  ];
}
